<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1"
        >Package Detail</v-stepper-step
      >

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2"
        >Economic Code</v-stepper-step
      >

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="3"
        >Package Steps</v-stepper-step
      >

      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <PackageDetail
          v-on:emitForm1="goNextStep"
          @setPackageId="setPackageIdToSiblings"
          @setMethodId="setMethodIdToSiblings"
        ></PackageDetail>
      </v-stepper-content>

      <v-stepper-content step="2">
        <EcoHeadAmount
          v-on:emitForm2="goNextStep"
          :package_id="get_package_id"
        ></EcoHeadAmount>
      </v-stepper-content>

      <v-stepper-content step="3">
        <StepDateEntry
          v-on:emitForm3="goNextStep"
          :package_id="get_package_id"
          :method_id="get_method_id"
        ></StepDateEntry>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
const commonService = require("../../../services/common.service");

import PackageDetail from "./step_forms/packageDetail";
import EcoHeadAmount from "./step_forms/ecoHeadAmount";
import StepDateEntry from "./step_forms/stepDateEntry";
export default {
  components: {
    PackageDetail,
    EcoHeadAmount,
    StepDateEntry,
  },
  data() {
    return {
      e1: 0,
      get_package_id: "",
      get_method_id: "",

      // formSchema: {
      //   //pro_code: "",
      // }
    };
  },

  created() {},

  methods: {
    submitOperationActivities() {
      commonService.insertFormData(formSchema, "proc_packages").then((res) => {
        if (res.status == 1) {
          this.e1 = 2;
        }
      });
    },

    goNextStep(num) {
      this.e1 = num;
    },
    setPackageIdToSiblings(id) {
      this.get_package_id = id;
    },
    setMethodIdToSiblings(id) {
      this.get_method_id = id;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package/packageForm.vue